module.exports = __webpack_public_path__ + "static/media/043.224bf775.jpg";